import styled from 'styled-components';
import { ColStyled } from '../ColStyled';

export const ColStyledAC = styled(ColStyled)``;
